import { useNavigation } from '@app/hooks/useNavigation';
import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { useEffect } from 'react';
import { getCelloConfig } from './celloConfig';

export function Cello() {
  const { user, whitelabelConfig, whitelabelLoading } = useUserWithCompany();
  const { navigation } = useNavigation();

  const celloConfig = getCelloConfig();

  useEffect(() => {
    if (!celloConfig.active) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = celloConfig.widgetLib;
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
      window.Cello?.('shutdown');
    };
  }, []);

  useEffect(() => {
    if (!celloConfig.active) return;
    if (
      !user?.celloToken ||
      !user?.celloActive ||
      ((whitelabelConfig || whitelabelLoading) && !user.hasFeature('WhitelabelAdmin'))
    )
      return;
    window.cello = window.cello || { cmd: [] };

    // only add the cello boot command if the list ist empty
    if (window.cello.cmd.length > 0) return;
    window.cello.cmd.push(async function (cello: any) {
      try {
        await cello.boot({
          productId: user?.celloProductId,
          token: user?.celloToken,
          language: user?.locale,
          productUserDetails: {
            email: user?.email,
          },
        });
      } catch (error) {
        console.error('Failed to boot cello:', error);
        // Handle the error appropriately
      }
    });
  }, [user?.celloToken, user?.celloActive, whitelabelConfig, whitelabelLoading]);
  return <></>;
}
